import React from 'react';
import {Spin} from 'antd';

export default function Loading({minHeight = 400}) {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight
        }}>
            <Spin size="large"/>
        </div>
    );
}